import React, {useCallback, useMemo} from 'react';
import Carousel from "react-bootstrap/Carousel";
import {useTheme} from "react-jss";

import styles from "./styles";
import classnames from "classnames";

UcCarousel.propTypes = {};

function UcCarousel(props = {}) {
  const {
    name = 'uc-carousel',
    className: carouselClassName,
    data: defaultData = [],
    children,
    numberOfColumns = 1,
    isFullWidth,
    indicators,
    controls,
    ...rest
  } = props;

  const theme = useTheme();
  const classes = styles({theme});
  const data = useMemo(() => {
    const results = [];
    if (defaultData?.length) {
      if (isFullWidth) {
        results.push(...defaultData);
      } else {
        const numberOfIterations = Math.ceil(defaultData.length / numberOfColumns);
        let sliceStart = 0;
        for (let i = 0; i < numberOfIterations; i++) {
          let sliceEnd = sliceStart + numberOfColumns;
          results.push(defaultData.slice(sliceStart, sliceEnd));
          sliceStart = sliceEnd;
        }
      }
    }

    return results
  }, [defaultData, isFullWidth, numberOfColumns]);


  const renderChildren = useCallback((children, props) => typeof children === "function" ? children(props) : React.cloneElement(children, props), [])

  return (<Carousel
    key={`${name}-${isFullWidth}`}
    className={classnames(classes.carouselStyle, carouselClassName)}
    indicators={data.length > 1}
    controls={controls ?? data.length > 1}
    interval={indicators ?? null}
    {...rest}
  >
    {data.map((elements, index) => (
      <Carousel.Item key={`${name}-${index}`}>
        {elements?.length ? elements.map(element => renderChildren(children, element)) : renderChildren(children, elements)}
      </Carousel.Item>))}
  </Carousel>);
}

export default UcCarousel;
